import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './index.css'
import { applyEnvironment, currentEnvironment, currentStatsSurface } from './lib/environment'

// SPEC-507: staging look (data-env, favicon). SPEC-510: tab title = host label on every host.
applyEnvironment(document, currentEnvironment(), currentStatsSurface())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
